<header class="aker-dark-theme">
  <div class="main-header">

    <!-- Brand chip (Completion / PROD) — collapses with the shared sidenav state. -->
    <a class="brand-chip" [class.collapsed]="!isOpen" [routerLink]="['', 'dashboard']" cdkMonitorElementFocus aria-label="Home">
      <img class="brand-chip-logo" src="assets/img/logo-white.svg" alt="Completion logo" />
      <span class="brand-chip-text">
        <span class="brand-chip-text-primary">Completion</span>
        <span class="brand-chip-text-accent">{{ envLabel }}</span>
      </span>
    </a>

    <div class="header-context-container">
      <div class="header-breadcrumbs">
        <app-breadcrumb [navigation]="true"></app-breadcrumb>
        <ng-content select="[breadcrumbs]"></ng-content>
      </div>
      <div>
        <app-context-title></app-context-title>
      </div>
    </div>

    <!-- Breadcrumbs / page-context slot. Consumers can project content here. -->


    <ng-content select="[akerTool]"></ng-content>

    <div class="toolbar-button-group" appUserManual [userManualKey]="'top-bar'">
      <button
        #searchTrigger
        type="button"
        class="search-button"
        mat-icon-button
        aria-label="Search"
        (click)="searchPopover.toggle($event)"
      >
        <mat-icon>search</mat-icon>
      </button>
      <p-popover #searchPopover [dismissable]="true" styleClass="header-search-popover">
        <div class="header-search-content">
          <span class="p-input-icon-left header-search-input-wrapper">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              [(ngModel)]="searchValue"
              (keyup.enter)="submitSearch(); searchPopover.hide()"
              placeholder="Search tags"
              aria-label="Search tags"
            />
          </span>
          <p-button
            icon="pi pi-times"
            severity="secondary"
            [text]="true"
            [disabled]="!searchValue"
            (onClick)="clearSearch()"
            ariaLabel="Clear search"
          ></p-button>
          <p-button
            label="Search"
            icon="pi pi-search"
            [disabled]="!searchValue"
            (onClick)="submitSearch(); searchPopover.hide()"
          ></p-button>
          <button
            type="button"
            class="search-help-button"
            aria-label="Open search user manual"
            title="Open user manual"
            (click)="openSearchManual()"
          >
            ?
          </button>
        </div>
      </p-popover>
      <app-launcher></app-launcher>
      @if (!hideUserLogin) {
        <app-user class="aker-user"><ng-content select="[HeaderMenuItems]"></ng-content></app-user>
      }
    </div>
  </div>
  @if (isLoading | async) {
    <mat-progress-bar [@fadeInAnimation]="{ value: ':enter', params: { delay: animationTime } }" mode="indeterminate"> </mat-progress-bar>
  }
</header>

<p-dialog
  header="Global Search User Manual"
  [(visible)]="searchManualDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(1000px, 96vw)' }"
  styleClass="header-search-manual-dialog"
>
  <div class="header-search-manual-content">
    <p>Use Search to find information in the project you are currently viewing.</p>

    <h3>How to search</h3>
    <ol>
      <li>Enter a search term.</li>
      <li>Select <strong>Search</strong> or press Enter.</li>
      <li>Select a link in the results to open the related item.</li>
    </ol>

    <h3>Searches for</h3>
    <table>
      <thead><tr><th>Looking for</th><th>What to enter</th><th>Example</th></tr></thead>
      <tbody>
        <tr><td>Tag</td><td>Tag number or any part of the tag name</td><td><code>E13L03</code> or <code>generator</code></td></tr>
        <tr><td>Checksheet</td><td>Checksheet number</td><td><code>CPCL-I-03</code></td></tr>
        <tr><td>Punch</td><td>Any word or phrase from the punch description</td><td><code>leak</code> or <code>cable</code></td></tr>
        <tr><td>User</td><td>SAP ID or any part of the user's name</td><td><code>505175</code> or <code>Ola</code></td></tr>
      </tbody>
    </table>

    <h3>Results</h3>
    <p>CP, MC package, and checksheet values are links. In the Punches tab, select the <strong>eye icon</strong> to open the punch.</p>
    <p class="header-search-manual-note"><strong>Note:</strong> Search only returns results from the active project.</p>
  </div>
</p-dialog>

